import axios from 'axios'

export interface MockAxiosResponse<T> {
  data: T
}

/**
 * The Axios Client to be configured
 */
const httpClient = axios.create({
  baseURL: 'https://bb-api.arizonadegreeplans.com',
  headers: { 'Content-Type': 'application/json' },
  // Plan generation can legitimately take 3-4 minutes; this only needs to catch
  // a truly unresponsive/down server, so it sits well above that worst case.
  timeout: 300000, // 5 minutes
})

export default httpClient